export var sortIceHockeyBothTeamToScore = function (x, y) {
    return x.id.endsWith("Q20") ? -1 : 1;
};
//# sourceMappingURL=sortIceHockeyBothTeamToScore.js.map